



















import Vue from 'vue'
import {mapActions, mapGetters, mapState} from 'vuex'
import Legenda from './Legenda.vue'
import {localizeMixin} from '../../mixins'

export default Vue.extend({
    mixins: [localizeMixin],
    components: {
        Legenda
    },
    data: () => ({}),
    computed: {
        ...mapGetters('auth', ['isAuthenticated']),
        ...mapState('user', ['userInfo'])
    },
    methods: {
        ...mapActions('modal', ['showModal']),
        ...mapActions('auth', ['logout'])
    }
})
